import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { adminSetup,user } from './admin-setup.component';
import { PosHttpService } from '../../../services/pos.http.service';

@Injectable({
  providedIn: 'root'
})
export class AdminSetupService {
  requestMap: any;

  constructor(
    private posHttpSvcs:PosHttpService,
  ) { }

  getAdminSetup():Observable<any>{
    return this.posHttpSvcs.authGet('v1/ui/adminSetup','adminSetup'); 
  }

  getUserRole():Observable<any>{
    return this.posHttpSvcs.authGet('v1/ui/roles','eoRole'); 
  }

  updateAdminSetup(objectHash: adminSetup): Observable<any> {
    this.requestMap=this.posHttpSvcs.appendHeaders({}, objectHash.appName)
    return this.posHttpSvcs.authPut('v1/ui/adminSetup', objectHash.appName ,objectHash);
  }

  getUser():Observable<any>{
    return this.posHttpSvcs.authGet('v1/ui/users','eoUser'); 
  }

  updateUser(objectHash: user): Observable<any> {
    this.requestMap=this.posHttpSvcs.appendHeaders({}, objectHash.username)
    return this.posHttpSvcs.authPost('v1/ui/user', objectHash.username ,objectHash);
  }

  deleteUser (primaryKey : number) : Observable<any> {
    this.requestMap=this.posHttpSvcs.appendHeaders({}, primaryKey)
    return this.posHttpSvcs.authDelete(`v1/ui/user/${primaryKey}`, primaryKey);
  }
}
